<template>
  <div class="page">
    <div class="header">
      <div class="description">
        <h1 class="title">Dashboard</h1>
      </div>

      <header-actions>
        <button-dropdown color="primary">
          <template slot="button-content">Nova Consulta</template>

          <button-dropdown-item type="link" :to="{ name: 'Compliance-Physical-Person-Create' }">Pessoa Física</button-dropdown-item>
          <button-dropdown-item type="link" :to="{ name: 'Compliance-Legal-Person-Create' }">Pessoa Jurídica</button-dropdown-item>
          <button-dropdown-item type="link" :to="{ name: 'Compliance-Vehicles-Create' }">Veículos</button-dropdown-item>
          <button-dropdown-item type="link" :to="{ name: 'Compliance-Others-Create' }">Outros Documentos</button-dropdown-item>
        </button-dropdown>
      </header-actions>
    </div>

    <div class="flex">
      <div class="w-full">
        <credit-consumption/>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderActions from '@/support/components/page/HeaderActions.vue';
import ButtonDropdown from '@/support/components/buttons/ButtonDropdown.vue';
import ButtonDropdownItem from '@/support/components/buttons/button-dropdown/ButtonDropdownItem.vue';
import CreditConsumption from '@/metrics/components/CreditConsumption.vue';

export default {
  name: 'Home',

  components: {
    HeaderActions,
    ButtonDropdown,
    ButtonDropdownItem,
    CreditConsumption,
  },
};
</script>

<style lang="scss" scoped>

</style>
